import { doSearch } from 'features/search';

function init () {

	const searchBox = document.getElementById('search');

	searchBox.addEventListener('focus', (e) => {

		const { target } = e;
		if (!target.tempPlaceholder) {

			target.tempPlaceholder = target.placeholder;

		}
		target.placeholder = '';

	});

	searchBox.addEventListener('blur', (e) => {

		const { target } = e;
		target.placeholder = target.tempPlaceholder;

	});

	// On Click of Search Button
	document.getElementById('searchBtn').addEventListener('click', (e) => {

		e.preventDefault();

		const searchMode = $('#hospitalityMaskSearchMode option:selected').text();
		const searchTextTerm = document.getElementById('search');
		const query = searchTextTerm.value.trim();

		if (searchMode === 'SKU') {

			const strSearchMaskDep = $('#searchMaskDep').val().trim();
			const strSearchMaskBase = $('#searchMaskBase').val().trim();
			const strSearchMaskFinish = $('#searchMaskFinish').val().trim();

			let strMashSearchUrl = `https://${window.location.host}/c/`;
			if (strSearchMaskDep !== '') {

				strMashSearchUrl += `hmdep_${strSearchMaskDep}/`;

			}
			if (strSearchMaskBase !== '') {

				strMashSearchUrl += `hmbase_${strSearchMaskBase}/`;

			}
			if (strSearchMaskFinish !== '') {

				strMashSearchUrl += `hmfinish_${strSearchMaskFinish}/`;

			}

			window.location = strMashSearchUrl;

		} else {

			doSearch(query);

		}

	});

}

export default init;
